export default function repeat<T>(times: number, cb: (index: number) => T) {
  const length = Number.isFinite(times) ? Math.max(0, Math.floor(times)) : 0;

  return Array.from({ length }, (_, index) => cb(index));
}
